<!-- camera-modal -->
<div class="modal fade camera-modal ainxt-tech-camera-modal" id="camera-modal" data-backdrop="static" data-keyboard="false" tabindex="-1">
	<!-- <div id="loader2" class="center" style="background: white;">
		<section class="common-section ainxt-tech-section">
			<div class="loader-api2" >
				<div class="loading-api">
					<div class="circle-loader">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
		</section>
	</div> -->
	
	<div id="loader2" class="center" style="background: white;">
			<section class="common-section ainxt-tech-section">
				<div class="container">
					<div class="row">
						<div class="col-lg-12" >
							<!-- <img width="150px" height="95.896" style="width: 150px; margin: 0 auto 15px;" src="../../assets/images/Ainxt-tech-logo-min-header-min.png" alt="Ainxt-tech-logo" class="ainxt-tech-logo" /> -->
							<div class="common-step-form">
								<h3 class="mb15 blackColor">Selfie Tips</h3>
								<p class="mt20" style="margin-top: 20px; color: #222;">Please remove Spectacles,Hats and masks. A clearly visible face will get approved fast</p>
								<!-- <div class="check-list-unstyled-outer" >
									<ul class="list-unstyled check-list-unstyled text-left">
										<li class="media">
											<img  width="24px" height="24px"  src="assets/images/icon/camera_Icon.svg" alt="" style="color: #ef4f27; font-size: 32px; margin-right: 30px;">
											<div class="media-body align-self-center">
												<p class="p-17">Permission to access camera</p>
											</div>
										</li>
										<li class="media">
											<img width="24px" height="24px" src="assets/images/icon/location_Icon.svg" alt="" style="color: #ef4f27; font-size: 32px; margin-right: 30px;">
											<div class="media-body align-self-center">
												<p class="p-17">Permission to access location</p>
											</div>
										</li>
									</ul>
								</div> 
								<p class="text-hdfc-red p-16 note-info" style="color: #646979 !important; margin-top: 10%;" >The selfie captured will be used for the purpose of account opening only.</p>-->
								<!-- <button class="btn common-btn common-btn-new btn-block" style="max-width: 420px;margin: auto;" >
									<img width="24px" height="18" src="assets/images/icon/icon-camera.svg" alt="icon-camera" class="common-camera-img mr10"  />
									Capture
								</button> -->
								<div class="selfieHand"><img src="../../../assets/images/selfie.png"   /></div>
								<p class="p-14 poweredby mt30 text-center">Powered by<b _ngcontent-mpl-c6="">AiNxt.</b>
</p>
							</div>
							
						</div>
					</div>
				</div>
			</section>
			<!-- <span class="">Checking Liveliness Configuration Please Wait  </span> -->
		</div>

	<div class="modal-dialog" id="cameraModel">
		<div class="modal-content" id="getreqired"s>
			<div class="modal-header1">
				<div class="container" style="display: flex;padding: 0;">
					<a class="icon-modal-close" data-dismiss="modal">
						<!-- <span (click)="toggleWebcam()" class="material-icons">arrow_back_ios</span> -->
						<img (click)="toggleWebcam()" width="32px" height="32px" src="assets/images/icon/arrow_back_ios.svg" alt="" style=" font-size: 32px; margin-right: 30px;">

					</a>
					<h5 class="modal-title">Phone Camera</h5>
				</div>
			</div>
					<div class="modal-body1 modal-body1-xs">
						<div class="camera-modal-inner camera-modal-inner-lg pb-0" *ngIf="showWebcam">
							<div class="modal-instruction modal-instruction-adj text-center" style="margin-bottom: 10px; margin-top: 10px;">
								<ul>
									<li id="newmessage">{{message }}</li>
								</ul>
							</div>
							<div class="camera-modal-inner-scale">
								<div class="camaeraDivOvel greenBorder" [ngClass]="{'border-red':!isSelfieCorrect, 'border-green':isSelfieCorrect}">
									<webcam id="webcam" #webcam  [trigger]="triggerObservable"
											(imageCapture)="handleImage($event)"
											[allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
											
											[videoOptions]="videoOptions" [imageQuality]="imageQuality"
											(cameraSwitched)="cameraWasSwitched($event)"
											(initError)="handleInitError($event)">
									</webcam>
								</div>
						
								<!-- <div class="ai-face-found" style="border-radius: 150px; overflow: hidden; -webkit-mask-image: -webkit-radial-gradient(center, circle cover, white 100%, black 100%); height: 300px; width: 300px;"> -->
								
								<!-- <div class="camera-oval-shape-outer camera-oval-shape" [ngClass]="{'border-red':!isSelfieCorrect, 'border-green':isSelfieCorrect}"> -->
									
									<!-- <webcam id="webcam" #webcam  [trigger]="triggerObservable"
											(imageCapture)="handleImage($event)" [height]="300" 
											[width]="300" 
											
											[allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
											[videoOptions]="videoOptions" [imageQuality]="imageQuality"
											(cameraSwitched)="cameraWasSwitched($event)"
											(initError)="handleInitError($event)" style="object-fit: cover;"></webcam> -->
								<!-- </div> -->
								<!-- </div> -->
							</div>

						</div>
					</div>


			<div class="modal-footer1" style="min-height:60px;" *ngIf="showWebcam && deviceId">
				<button id="selfieButtonIcon" type="button" class="btns-camera btns-camera-1" appPreventDoubleClick (click)="triggerSnapshot();"  (click)="stope()" >
					<span class="material-icons">
						camera
					</span>
				</button>
				<audio #clickSound>
					<source src="../../assets/images/shutter.mp3" type="audio/mp3">
				</audio>
				<p class="p-14 mt20 poweredby  text-center">Powered by <b _ngcontent-mpl-c6="">AiNxt.</b>
</p>

			</div>
		</div>
	</div>
</div>

<!-- camera-denied-modal -->
<div class="modal fade preview-img-modal" id="camera-denied-modal" data-backdrop="static" data-keyboard="false"
	 tabindex="-1">
	<div class="modal-dialog modal-dialog-centered modal-md">
		<div class="modal-content" >
			<div class="modal-header">
				<h5 class="modal-title" id="staticBackdropLabel">Allow Permissions</h5>
				<a class="icon-modal-close" data-dismiss="modal">
					<img src="assets/images/icon/icon-modal-close.svg" alt="icon-modal-close"
						 class="icon-modal-close-img" />
				</a>
			</div>
			<div class="modal-body">
				<div class="common-modal-inner-2">
					<div class="camera-code-wrap mb15">
						<h5>
							Camera Permission is denied:
						</h5>
						<p class="p-16 mb15">Steps to continue to use camera</p>
						<ul class="camera-permission-ul">
							<li class="p-16"> <em>1</em> Click the lock icon on top-left of the screen.</li>
							<li class="p-16"> <em>2</em> Click "Site Settings"</li>
							<li class="p-16"> <em>3</em> Click "Clear &amp; reset"</li>
							<li class="p-16"> <em>4</em> Click on "Retry Button"</li>
						</ul>
						<p class="p-14">
							<b>Note:</b> If you didn't deny camera permission, kindly copy the link and open in Chrome
							Browser.
						</p>
						<button class="btn common-btn btn-block"
								style="min-width: 140px; margin-top: 20px !important; margin-bottom: 15px !important; background: #ef4f27!important;"
								id="btn-icon-camera" data-dismiss="modal" appPreventDoubleClick (singleClick)="toggleWebcam()">
							<span class="material-icons mr10">sync</span>
							RETRY
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

